import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Moment from "moment";

import EmployeeService from "../../../services/Employee.service";
import UnvestedAwardDetailsDialog from "../common/dialogs/UnvestedAwardDetailsDialog";
import VestedAwardDetailsDialog from "../common/dialogs/VestedAwardDetailsDialog";
import VestElectionsDialog from "../common/dialogs/VestElectionsDialog"
import FractionalSharesDialog from "../common/dialogs/FractionalSharesDialog";
import VestTile from "../common/tiles/VestTile";
import { RouterLink, NavigationTo } from "../../../layouts/v2/common"
import { COMPONENT_IDS } from '../common/common';

import { Row, Col, Spacer } from '@amzn/stencil-react-components/layout'
import { WithBreakpoints } from '@amzn/stencil-react-components/responsive'
import { Text, Label, H2 } from '@amzn/stencil-react-components/text'

export class VestingSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vestSummaryDialogVisible: false,
      transactionSummaryDialogVisible: false,
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: false,
      awardWithVest: { award: null, vest: null},
      awardWithTransaction: { award: null, transaction: null},
      transactionEvents: null,
      vestEvents: null,
      recentVestDate: props.summary.recent_vested ? props.summary.recent_vested.transaction_date : null,
      upcomingVestDate: props.summary.next_vest ? props.summary.next_vest.next_vest_date: null,
    };
  }

  selectTransactionEvent = (events, award_id = null, transaction_id = null) => {
    this.setState({
      transactionSummaryDialogVisible: true,
    });

    if (award_id != null && transaction_id != null) {
      this.setState({
        awardWithTransaction: EmployeeService.loadAwardWithTransaction(
          this.props.employee,
          award_id,
          transaction_id
        )
      });
    } else {
      this.setState({
        awardWithTransaction: {award: null, transaction: null}
      });
    }

    if (events.length > 1) {
      this.setState({
        transactionEvents: events,
      })
    }
  };

  selectVestEvent = (events, awardId = null, vestId = null) => {
    this.setState({
      vestSummaryDialogVisible: true,
    });

    if (awardId != null && vestId != null) {
      this.setState({
        awardWithVest: EmployeeService.loadAwardWithVest(
          this.props.employee,
          awardId,
          vestId
        )
      });
    } else {
      this.setState({
        awardWithVest: {award: null, vest: null}
      })
    }

    if (events.length > 1) {
      this.setState({
        vestEvents: events,
      })
    }
  };

  vestElectionsOnChangeTaxPayment = () => {
    this.setState({
      vestElectionsDialogVisible: false,
    })

    this.getNextVestButtonFocus();
  }

  onVestElectionsDialogDeliveryMethodChange = () => {
    this.setState({
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: true
    })
  }

  onCloseFractionalSharesDialog = () => {
    this.setState({
      fractionalSharesDialogVisible: false
    })

    this.getNextVestButtonFocus();
  }

  vestElectionsOnClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      vestElectionsDialogVisible: true,
      vest: vest
    })
  }

  onVestElectionsDialogClose = () => {
    this.setState({
      vestElectionsDialogVisible: false
    });

    this.getNextVestButtonFocus();
  }

  onChangePaymentMethod = (vest) => {
    if (this.props.fractionalMode){
      this.vestElectionsOnClick(vest)
    }
  }

  renderVestingSummaryHeader = (t) => {
    return (
      <Row flexWrap="wrap" alignItems="center">
        <H2 id={COMPONENT_IDS.VestingSummary} tabIndex="-1">
          {t("VestingSummary.Title")}
        </H2>
        <Spacer flex={1}/>
        <RouterLink
          to={NavigationTo.StockAwards}
          fontSize="T100"
        >
          {t("VestingSummary.SeeStockAwardsLink")}
        </RouterLink>
      </Row>
    )
  }

  renderUnvestedTile = (t, summary) => {
    let remainingRsu = new Intl.NumberFormat(this.props.locale).format(summary.unvested.remaining_rsu);

    const unvestedTile = (
      <>
        <Label role="heading" aria-level="3" fontSize="T100" fontWeight="meduim" color="neutral70" htmlFor="as-of-label">
          {t("VestingSummary.TotalUnvestedRsusTitle")}
        </Label>
        <VestTile
          height="100%"
          date={t("VestingSummary.AsOfDate", {
              date: Moment(summary.unvested.date).format("LL")
            })}
          info={t("VestingSummary.UnvestedRemainingRsuInfo", {
              remaining_rsu: remainingRsu
            })}
          footerTop={t("VestingSummary.UnvestedActiveAwardsInfo", {
              active_awards: summary.unvested.active_awards
            })}
          id="as-of-label"
          isVestingSummary={true}
        />
      </>
    );

    return (
      <WithBreakpoints>
        {({ matches }) => (
          <>
          {matches.s &&
            <Col width="100%" gridGap="S200">
              {unvestedTile}
            </Col>
          }
          {!matches.s &&
            <Col gridGap="S200">
              {unvestedTile}
            </Col>
          }
          </>
        )}
      </WithBreakpoints>
    );
  }

  renderRecentVestTile = (t, summary) => {
    let sharesTransacted = new Intl.NumberFormat(this.props.locale).format(summary.recent_vested.shares_transacted);
    let netShares = new Intl.NumberFormat(this.props.locale).format(summary.recent_vested.net_shares);

    const recentTile = (
      <>
        <Label role="heading" aria-level="3" fontSize="T100" fontWeight="medium" color="neutral70" htmlFor="recent-vest">
          {t("VestingSummary.MostRecentVestDateTitle")}
        </Label>
        <VestTile
          height="100%"
          date={Moment(summary.recent_vested.transaction_date).format(
              "LL"
            )}
          headerBadgeLabel={summary.recent_vested.events.length > 1 ? t('VestingSummary.EventButtonText', {number_events: summary.recent_vested.events.length }) : null}
          info={t("VestingSummary.RecentVestedRSUVested", {
              shares_transacted: sharesTransacted
            })}
          footerTop={t("VestingSummary.RecentVestedNetSharesInfo", {
              net_shares: netShares
            })}
          footerMid={EmployeeService.getBrokers(t, summary.recent_vested.tax_broker_name, summary.recent_vested.net_broker_name, summary.recent_vested.mobile_tax_sale_in)[0]}
          footerBottom={EmployeeService.getBrokers(t, summary.recent_vested.tax_broker_name, summary.recent_vested.net_broker_name, summary.recent_vested.mobile_tax_sale_in)[1]}
          isClickable={true}
          onTileClick={() => this.selectTransactionEvent(summary.recent_vested.events, this.getEventAwardIdIfOnlyOne(summary.recent_vested.events), this.getEventTransactionIdIfOnlyOne(summary.recent_vested.events))}
          id="recent-vest"
          isVestingSummary={true}
        />
      </>
    );

    return (
      <WithBreakpoints>
        {({ matches }) => (
          <>
            {matches.s &&
              <Col width="100%" gridGap="S200">
                {recentTile}
              </Col>
            }
            {!matches.s &&
              <Col gridGap="S200">
                {recentTile}
              </Col>
            }
          </>
        )}
      </WithBreakpoints>
    );
  }

  renderNextVestTile = (t, summary) => {
    let sharesVest = new Intl.NumberFormat(this.props.locale).format(summary.next_vest.shares_vest);

    let taxTreatment = summary.next_vest.tax_treatment;

    const nextTile = (
      <>
        <Label role="heading" aria-level="3" fontSize="T100" fontWeight="medium" color="neutral70" htmlFor="next-vest">
          {t("VestingSummary.NextVestDateTitle")}
        </Label>
        <VestTile
          height="100%"
          date={Moment(summary.next_vest.next_vest_date).format("LL")}
          headerBadgeLabel={summary.next_vest.events.length > 1 ? t('VestingSummary.EventButtonText', {number_events: summary.next_vest.events.length }) : null}
          info={t("VestingSummary.NextVestSharesVestInfo", {
            shares_vest: sharesVest
          })}
          footerTop={t("TaxTreatment." + taxTreatment)}
          footerMid={EmployeeService.getBrokers(t, summary.next_vest.tax_broker_name, summary.next_vest.net_broker_name, summary.next_vest.mobile_tax_sale_in)[0]}
          footerBottom={EmployeeService.getBrokers(t, summary.next_vest.tax_broker_name, summary.next_vest.net_broker_name, summary.next_vest.mobile_tax_sale_in)[1]}
          isClickable={true}
          onTileClick={() => this.selectVestEvent(summary.next_vest.events, this.getEventAwardIdIfOnlyOne(summary.next_vest.events), this.getEventVestIdIfOnlyOne(summary.next_vest.events))}
          id={COMPONENT_IDS.NextVest}
          isVestingSummary={true}
        />
      </>
    );

    return (
      <WithBreakpoints>
        {({ matches }) => (
          <>
            {matches.s &&
              <Col width="100%" gridGap="S200">
                {nextTile}
            </Col>
            }
            {!matches.s &&
              <Col gridGap="S200">
                {nextTile}
              </Col>
            }
          </>
        )}
      </WithBreakpoints>
    );
  }

  getEventAwardIdIfOnlyOne = (events) => {
    return events.length === 1 ? events[0].award_id : null;
  }

  getEventTransactionIdIfOnlyOne = (events) => {
    return events.length === 1 ? events[0].transaction_id : null;
  }

  getEventVestIdIfOnlyOne = (events) => {
    return events.length === 1 ? events[0].vest_id : null;
  }

  getNextVestButtonFocus = () => {
    document.getElementById(COMPONENT_IDS.NextVest).focus();
  }

  render() {
    const { t, summary } = this.props;

    if (
      summary.unvested === null &&
      summary.recent_vested === null &&
      summary.next_vest === null
    ) {
      return (
        <Col gridGap="S400">
          {this.renderVestingSummaryHeader(t)}
          <Text>{t("VestingSummary.NoSummary")}</Text>
        </Col>
      );
    }

    return (
      <Col gridGap="S400">
        {this.renderVestingSummaryHeader(t)}
        <Row gridGap="S300" flexWrap="wrap">
          {summary.unvested &&
            this.renderUnvestedTile(t, summary)
          }
          {summary.recent_vested &&
            this.renderRecentVestTile(t, summary)
          }
          {summary.next_vest &&
            this.renderNextVestTile(t, summary)
          }
          <UnvestedAwardDetailsDialog
            visible={this.state.vestSummaryDialogVisible}
            award={this.state.awardWithVest.award}
            vest={this.state.awardWithVest.vest}
            broker={this.state.awardWithVest.tax_broker}
            brokers={this.state.awardWithVest.award ? EmployeeService.getBrokers(t, this.state.awardWithVest.award.tax_broker.name, this.state.awardWithVest.award.net_broker.name, this.state.awardWithVest.award.mobile_tax_sale_in) : null}
            onClose={() => this.setState({ vestSummaryDialogVisible: false })}
            onChangePaymentMethodClick={this.onChangePaymentMethod}
            events={this.state.vestEvents}
            onSelectEvent={(events, awardId, vestId) => this.selectVestEvent(events, awardId, vestId)}
            date={this.state.upcomingVestDate}
          />
          <VestedAwardDetailsDialog
            visible={this.state.transactionSummaryDialogVisible}
            award={this.state.awardWithTransaction.award}
            brokers={this.state.awardWithTransaction.award ? EmployeeService.getBrokers(t, this.state.awardWithTransaction.award.tax_broker.name, this.state.awardWithTransaction.award.net_broker.name, this.state.awardWithTransaction.award.mobile_tax_sale_in) : null}
            transaction={this.state.awardWithTransaction.transaction}
            events={this.state.transactionEvents}
            onClose={() => this.setState({ transactionSummaryDialogVisible: false })}
            onSelectEvent={(events, awardId, transactionId) => this.selectTransactionEvent(events, awardId, transactionId)}
            date={this.state.recentVestDate}
          />
          <VestElectionsDialog
            visible={this.state.vestElectionsDialogVisible}
            onChangeDeliveryMethodButtonClick={this.onVestElectionsDialogDeliveryMethodChange}
            onDialogClose={this.onVestElectionsDialogClose}
            awardIdSelected={this.state.awardIdSelected}
            vest={this.state.vest}
            calendarYear={this.state.calendarYear}
          />
          <FractionalSharesDialog
            visible={this.state.fractionalSharesDialogVisible}
            onDialogClose={this.onCloseFractionalSharesDialog}
            idFrom={COMPONENT_IDS.NextVest}
          />
        </Row>
      </Col>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  summary: state.employee.summary,
  locale: state.employee.language,
  fractionalMode: state.static_content.fractional_mode
});

export default connect(mapState)(withTranslation("translationsV2")(VestingSummary));
